export const updateManual = async (recordId, updateData) => {
  const conn_name = "crmwidgetconnection";
  const apiUrl = `https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Quality_Manual_Report/${recordId}`;

  const payload = {
    parameters: {
      data: updateData, // Pass the updated fields
    },
    method: "PATCH",
    url: apiUrl,
    param_type: 2,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("Update Response:", response);

    if (response.code === "SUCCESS") {
      Swal.fire({
        title: "Manual Updated",
        text: "Changes saved successfully.",
        icon: "success",
      });
      return true; // Indicate success
    } else {
      alert("Failed to update: " + (response.message || "Unknown error"));
      return false; // Indicate failure
    }
  } catch (err) {
    console.error("Update error:", err);
    alert("Error while updating record.");
    return false; // Indicate failure
  }
};
